@if (!searchField) {
  <mat-form-field color="primary" appearance="outline">
    <mat-label>{{ label }}</mat-label>
    <input matInput [type]="type" [formControl]="control" />
  </mat-form-field>
}

@if (searchField) {
  <mat-form-field class="w-full" color="primary">
    <mat-label>Search</mat-label>
    <input matInput [type]="type" [formControl]="control" />
  </mat-form-field>
}
